import React from 'react';
import { Link } from 'react-router-dom';
import services from '../data/services';
import Icon from './Icon';
import Logo from './Logo';
import './Footer.css';

const EMAIL = 'eatsleepcodereapeat@gmail.com';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-brand">
            <Link to="/" aria-label="ESCR LLC home">
              <Logo />
            </Link>
            <p className="footer-description">
              ESCR (Eat · Sleep · Code · Repeat) is a software engineering studio building web, mobile and cloud
              products for ambitious teams.
            </p>
            <a href={`mailto:${EMAIL}`} className="footer-email">
              {EMAIL}
              <Icon name="arrowUpRight" />
            </a>
          </div>

          <div className="footer-cols">
            <div className="footer-col">
              <h2 className="footer-title">Services</h2>
              <ul>
                {services.map((service) => (
                  <li key={service.slug}>
                    <Link to={`/services/${service.slug}`}>{service.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="footer-col">
              <h2 className="footer-title">Company</h2>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/portfolio">Portfolio</Link></li>
                <li><Link to="/blogs">Blog</Link></li>
              </ul>
            </div>
            <div className="footer-col">
              <h2 className="footer-title">Contact</h2>
              <ul>
                <li><a href={`mailto:${EMAIL}`}>Email us</a></li>
                <li><a href="tel:+381606500893">+381 60 6500 893</a></li>
                <li><Link to="/contact">Project inquiry</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-wordmark" aria-hidden="true">
          eat.sleep.code<span>.repeat()</span>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} ESCR LLC. All rights reserved.</p>
          <p className="footer-status">
            <span className="status-dot" aria-hidden="true" />
            Available for new projects
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
